const menuTheme = {};
export default menuTheme;
